// extracted by mini-css-extract-plugin
export var container = "_7r-0";
export var icon = "_7r-1";
export var text = "_7r-2";